module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPlay),
      expression: "showPlay"
    }],
    staticClass: "kgmusic"
  }, [_c('section', [_c('div', {
    staticClass: "play"
  }, [_vm._m(0), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.imgUrl
    },
    on: {
      "click": function($event) {
        _vm.record_msg()
      }
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.songName))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.singerName))]), _vm._v(" "), _c('i', {
    staticClass: "playButton",
    class: {
      'active': _vm.isClick
    },
    on: {
      "click": _vm.playStatus
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "more",
    on: {
      "click": _vm.showMore
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "play_audio"
  }, [_c('audio', {
    attrs: {
      "src": _vm.music_src,
      "controls": "controls",
      "autoplay": "autoplay",
      "id": "audio"
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "actionSheet_wrap"
    }
  }, [_c('div', {
    staticClass: "weui-mask_transparent actionsheet__mask",
    class: {
      'active': _vm.isShowMask
    },
    attrs: {
      "id": "mask"
    },
    on: {
      "click": _vm.hide
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-actionsheet",
    class: {
      'weui-actionsheet_toggle': _vm.isShowMore
    },
    attrs: {
      "id": "weui-actionsheet"
    }
  }, [_c('div', {
    staticClass: "weui-actionsheet__menu"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.songsPlay), function(n, index) {
    return _c('div', {
      staticClass: "weui-actionsheet__cell",
      attrs: {
        "id": index
      }
    }, [_c('span', {
      class: {
        'icondiy-play': _vm.page === index
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "songsName",
      on: {
        "click": function($event) {
          _vm.icondiyPlay(index, n.hash)
        }
      }
    }, [_vm._v(_vm._s(n.filename))]), _vm._v(" "), _c('a', {
      attrs: {
        "href": _vm.music_src,
        "download": n.filename,
        "id": "down"
      }
    }, [_c('i', {
      staticClass: "iconfont icon-xiazai1",
      on: {
        "click": function($event) {
          _vm.download()
        }
      }
    })])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "weui-actionsheet__action"
  }, [_c('div', {
    staticClass: "weui-actionsheet__cell cancel",
    attrs: {
      "id": "actionsheet_cancel"
    },
    on: {
      "click": _vm.hide
    }
  }, [_vm._v("关闭")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "progress"
    }
  }, [_c('span', {
    attrs: {
      "id": "bar"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span'), _vm._v("播放列表")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5738fd0f"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xplay.vue
// module id = 262
// module chunks = 0